<template>
    <div class="container">
        <h2>{{ $t("public.whereToStay.find_place_to_stay") }}</h2>
        <iframe v-bind:src="stay22Url" id="stay22-widget" width="100%" height="90%" frameborder="0"></iframe>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            stay22Url: ""
        }
    },
    methods: {
        adjustStay22Url() {
            axios.post("https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBioxu4333OU-NfR_Ivb-l53D6hNO_8aUE").then((response) => {
                const latitude = response.data.location.lat;
                const longitude = response.data.location.lng;
                if (latitude && longitude) {
                    this.stay22Url = "https://www.stay22.com/embed/gm?aid=5fa688c165be910017fd0a87&lat=" + latitude + "&lng=" + longitude + "&maincolor=#224460";
                } else {
                    this.stay22Url = "https://www.stay22.com/embed/gm?aid=5fa688c165be910017fd0a87&lat=46&lng=-73.987777&maincolor=#224460";
                }
            }).catch(() => {
                this.stay22Url = "https://www.stay22.com/embed/gm?aid=5fa688c165be910017fd0a87&lat=46&lng=-73.987777&maincolor=#224460";
            });
        }
    },
    mounted() {
        this.adjustStay22Url();
    }
}
</script>

<style scoped>
.container {
    margin: 0;
    max-width: 100%;
    width: 100%;
}
</style>